<template>
  <div class="consult-bar-component"
       :style="{
          background:
          `linear-gradient(
            to top,
            ${color.top},
            ${color.bottom}
          )`
       }"
  >
    <a class="consult-bar-btn"
       :href="telHref"
    >
      电话咨询
    </a>
    <a v-if="isWechat && wechatUrl !== ''"
       class="consult-bar-btn"
       :href="wechatUrl"
    >
      微信咨询
    </a>
  </div>
</template>

<script>
  import { CONSUMER_HOTLINE } from '@/utils/constant';
  import { isWeiXinBrowser } from '@/utils';

  export default {
    name: 'ConsultBar',
    props: {
      color: {
        type: Object,
      },
      tel: String,
      wechatUrl: String,
    },
    computed: {
      telHref() {
        const { tel } = this;
        return `tel:${tel == null ? tel : CONSUMER_HOTLINE}`;
      },
      isWechat() {
        return isWeiXinBrowser();
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .consult-bar {
    &-component {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      color: @color-white;
    }

    @btn-border-height: 64px;

    &-btn {
      flex: 1;
      height: 100%;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      &:not(:last-child) {
        &::after {
          content: '';
          width: 1px;
          height: @btn-border-height * 2;
          position: absolute;
          top: 50%;
          right: 0;
          background: @color-white;
          transform: translateY(-50%) scale(.5);
        }
      }
    }
  }
</style>
